import { Badge, Card, message, Space, Tag } from "antd";
import { IVideo } from "../../interfaces";
import VideoDetail, { IURL } from "./VideoDetail";
import StudioPlayer from "./StudioPlayer";
import ActionButton from "./ActionButton";
import { ICourse } from "../../screens/list";
import { RTMP_SERVER, studioApi } from "../../api";
import { useEffect, useState } from "react";
import { useMount } from "../../hooks";
import { statusColor } from "../../utils/constants";
import Engagement from "../../utils/engagement";
import StudioVideoDetails from "../../screens/studioVideoDetails";
import { MessageOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import DelayFormModal from "../delay/delayFormModal";

type TProps = {
  video: IVideo;
  onDone: (video: IVideo) => void;
  frameKey: number;
  course: ICourse;
  player: "old" | "new";
  setPlayer: (player: "old" | "new") => void;
};

function LiveStudio({
  video,
  onDone,
  frameKey,
  course,
  player,
  setPlayer,
}: TProps) {
  const [playerUrls, setPlayerUrls] = useState<IURL[]>([]);
  const [activeUrl, setActiveUrl] = useState(playerUrls[0]);
  const [activeTab, setActiveTab] = useState<
    "details" | "engagement" | "admin" | "delay"
  >("details");

  useMount(() => {
    const urls = [
      {
        label: "RTMP Video",
        value: `${localStorage.getItem("live_CDN") || RTMP_SERVER}/hls/${
          video.stream_key
        }.m3u8&is_live=1`,
      },
    ];
    setPlayerUrls(urls);
    setActiveUrl(urls[0]);
  }, [video?.stream_key]);
  const tabs = [
    {
      key: "details",
      label: "Video Details",
    },
    {
      key: "admin",
      label: "Admin Details",
    },
    {
      key: "engagement",
      label: "Engagement",
    },
    // {
    //   key: "delay",
    //   label: "Operator's Remark",
    // },
  ] as const;

  const handleOpenChatViewer = async () => {
    if (!video?.stream_key) {
      message.warning("Stream key not found");
      return;
    }

    try {
      const { data } = await studioApi.get(`/videos/stream-key`, {
        params: { stream_key: video.stream_key },
      });
      const roomIds = data?.map((v: any) => v.vid)?.join(",");
      console.log(roomIds, "printing room ids");
      const token = localStorage.getItem("AUTH_TOKEN");
      const url = `https://chats.kgs.live/?roomId=${roomIds}&token=${token}&medium=studio`;

      window.open(url, "_blank");
    } catch (error) {
      console.error(error);
      message.error("Failed to open chat viewer");
    }
  };
  const [videoDetails, setVideoDetails] = useState<any>(null);

  const [isDelayModalOpen, setIsDelayModalOpen] = useState(false);

  const getVideoDetails = async () => {
    try {
      const { data } = await studioApi.get(`/cms/videos/${video.vid}`);

      setVideoDetails(data);
    } catch (error) {
      console.error(error);
      message.error("Failed to fetch video details");
    }
  };
  useEffect(() => {
    if (video?.vid) {
      getVideoDetails();
    }
  }, [video?.vid]);

  const videoUrl =
    video.videoType === "ytst"
      ? video.url
      : video.status === "rendered"
      ? video.video_url
      : `${RTMP_SERVER}/hls/${video.stream_key}.m3u8`;

  useEffect(() => {
    if (!videoDetails) return;
    const publishedAt = videoDetails?.published_at;
    const startAt = videoDetails?.details?.start_at;
    const delayMsg = videoDetails?.details?.delay_msg;
    if (!publishedAt || !startAt) return;
    const diffMinutes = dayjs(startAt).diff(dayjs(publishedAt), "minute", true);
    if (diffMinutes > 2 && delayMsg == null) {
      setIsDelayModalOpen(true);
    }
  }, [videoDetails]);


  return (
    <div
      style={{
        overflow: "scroll",
        height: "100%",
        width: "100%",
      }}
    >
      <Card
        title={
          <div className="flex items-center gap-2 w-full pr-4">
            <span>{`# ${video?.vid} Video Details`}</span>

            <button
              onClick={handleOpenChatViewer}
              className="
                flex items-center gap-2
                rounded-lg bg-blue-900
                px-4 py-1
                text-sm font-semibold text-white
                shadow-lg
                transition-all duration-300
                active:scale-95
              "
            >
              <MessageOutlined className="text-base" />
              <span>View all chats</span>
            </button>
          </div>
        }
        type="inner"
        style={{ overflow: "hidden", marginBottom: 10 }}
        extra={
          <Space>
            <Tag color={statusColor[`${video.status}`]}>
              <Badge
                color={
                  video.status === "rendering"
                    ? "orange"
                    : video.status === "live"
                    ? "green"
                    : "#A9A9A9"
                }
                text={video.status}
              />
            </Tag>
            <ActionButton onDone={onDone} video={video} />
          </Space>
        }
      >
        {video.stream_key !== undefined && (
          <StudioPlayer player={player} key={frameKey} videoUrl={videoUrl} />
        )}

        <div className="flex items-center gap-2 mb-4 border-b border-slate-200 pb-3 my-4">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`px-4 py-1.5 rounded-md text-sm font-medium transition-all cursor-pointer ${
                activeTab === tab.key
                  ? "bg-blue-900 text-white shadow-sm"
                  : "bg-slate-100 text-slate-600 hover:bg-slate-200"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {activeTab === "details" && (
          <VideoDetail
            player={player}
            setPlayer={setPlayer}
            playerUrls={playerUrls}
            activeUrl={activeUrl}
            onChangeUrl={() => console.log("unable to change url")}
            latest={video}
            course={course!}
          />
        )}

        {activeTab === "engagement" && <Engagement roomId={video?.vid} />}

        {activeTab === "admin" && (
          <StudioVideoDetails
            vId={video?.vid!}
            status={true!}
            streamKey={video?.stream_key!}
          />
        )}
   
        {/* <DelayFormModal
          open={isDelayModalOpen}
          onSuccess={() => {
            setIsDelayModalOpen(false);
            getVideoDetails();
          }}
          videoId={video.vid!}
        /> */}

        {/* {video.stream_key && <VideoLinks latest={video} />} */}
      </Card>
    </div>
  );
}

export default LiveStudio;
